import { Button, chakra, VStack, ButtonGroup, Container, Box, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AccountContext } from '../../../AccountContext';
import NoUserHeader from '../../../AreaLivre/NoUserHeader';
import BottomNavBar from '../../../BottomNavBar';
import ChildHeader from '../ChildHeader';
import _ from 'lodash';
import { api } from 'api/api';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function ConferePedido() {
  const navigate = useNavigate();
  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');
  const { user, setUser, setPage } = useContext(AccountContext);
  const { state } = useLocation();
  const { id_contrato, titular } = user;
  const [splitRulesData, setSplitRulesData] = useState(null);
  const [currentDate, setCurrentDate] = useState(null);
  const [preparos, setPreparos] = useState([]);
  setPage('Pedido');
  console.log(state);
  const backgroundColor =
    titular === true && id_contrato === 0
      ? '#5AB2AE'
      : titular === false && id_contrato === 0
        ? '#5AB2AE'
        : titular === true && id_contrato > 0
          ? '#5AB2AE'
          : '#5AB2AE';

  // useEffect para pegar dados de split
  useEffect(() => {
    const medicoSelecionado = state.item.find((objeto) => objeto?.medico_selecionado)?.medico_selecionado;
    let split_rules_info = {
      procedimento_tuss_id: state.item.map((e) => e.procedimento_tuss_id),
      medico_selecionado: medicoSelecionado,
      id_empresa_recebe: state.empresa.empresa_id,
      convenio: state.convenio,
    };
    setSplitRulesData(split_rules_info);

    let currData = getMinorDateFromItemCart(state.item);
    const [ano, mes, dia] = currData.split('-').map(Number);
    const data = new Date(ano, mes - 1, dia); // O mês é indexado em zero (janeiro é 0), então subtraímos 1
    setCurrentDate(data);
    let procedimentos = [];

    user.cart.itens.forEach((procedimento) => {
      procedimentos.push(procedimento.procedimento_tuss_id);
    });

    const payload = {
      procedimentos: procedimentos,
    };

    async function getPreparos() {
      const url = `${ENDPOINT}/schedule/searchHierar`;
      const response = await api(url, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(payload),
      });
      const postsData = await response.json();
      setPreparos(postsData?.data);
    }
    getPreparos();
  }, []);

  const confirmEstimate = (id) => {
    if (id > 0) {
      const postData = api(`${ENDPOINT}/cart/estimate/${id}/confirm`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => {
        if (res.status === 200) {
          let newCartItems = _.filter(user.solicitacoes, (item) => !_.includes([id], item.ambulatorio_orcamento_id));
          if (newCartItems.length === 0) {
            setUser((prevState) => ({ ...prevState, solicitacoes: {} }));
          } else {
            setUser((prevState) => ({ ...prevState, solicitacoes: { ...newCartItems } }));
          }
        }
      });
    }
  };

  const parseDateValue = (value) => {
    if (!value) return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

    if (typeof value === 'string') {
      const [datePart] = value.split(/[T ]/);
      const match = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);

      if (match) {
        const [, year, month, day] = match;
        return new Date(Number(year), Number(month) - 1, Number(day));
      }
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const formatDateForDisplay = (value) => {
    const date = parseDateValue(value);

    if (!date) return null;

    const weekDay = date.toLocaleDateString('pt-br', { weekday: 'long' });
    const dateText = date.toLocaleDateString('pt-br', { day: '2-digit', month: '2-digit', year: 'numeric' });

    return `${weekDay.charAt(0).toUpperCase() + weekDay.slice(1)}, ${dateText}`;
  };

  const formatTimeForDisplay = (value) => {
    if (!value) return null;

    const [hour, minute] = String(value).split(':');

    if (!hour || !minute) return String(value);

    return `${hour}:${minute}h`;
  };

  const getPeriodForDisplay = (value) => {
    if (!value) return '';

    const [hour, minute = '0'] = String(value).split(':');
    const hourNumber = Number(hour);
    const minuteNumber = Number(minute);

    if (Number.isNaN(hourNumber) || Number.isNaN(minuteNumber)) return '';

    return hourNumber * 60 + minuteNumber > 12 * 60 ? 'Tarde' : 'Manhã';
  };

  const getDateKey = (value) => {
    const date = parseDateValue(value);

    if (!date) return '9999-99-99';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const isTruthy = (value) => {
    return value === true || value === 'true' || value === 1 || value === '1';
  };

  const toTitleCase = (value) => {
    if (!value || typeof value !== 'string') return '';

    return value
      .toLocaleLowerCase('pt-br')
      .replace(/(^|\s)\S/g, (letter) => letter.toLocaleUpperCase('pt-br'));
  };

  const getProcedureDateValue = (procedimento) => {
    return procedimento?.dia_selecionado || (state.item.length === 1 ? state.data : null);
  };

  const getProcedureHourValue = (procedimento) => {
    return procedimento?.horario || procedimento?.hora_selecionada_display || (state.item.length === 1 ? state.horario : null);
  };

  const getProcedureScheduleParts = (procedimento) => {
    const dateValue = getProcedureDateValue(procedimento);
    const dateText = formatDateForDisplay(dateValue);
    const hourValue = getProcedureHourValue(procedimento);
    const hourText = formatTimeForDisplay(hourValue);
    const isByOrder = isTruthy(procedimento?.agenda_ordem_chegada) || isTruthy(procedimento?.ordem_chegada) || isTruthy(procedimento?.isByOrder);
    const periodText = getPeriodForDisplay(hourValue);
    const detailText = isByOrder
      ? `${periodText ? `${periodText} — ` : ''}Ordem de chegada`
      : hourText
        ? `${periodText ? `${periodText} — ` : ''}${hourText}`
        : null;

    return {
      dateText,
      detailText,
      dateKey: getDateKey(dateValue),
      hourValue,
      sortTime: hourValue || '99:99',
      scheduleKey: isByOrder ? `order-${periodText || 'periodo'}` : hourValue || 'sem-horario',
    };
  };

  const getDoctorDisplayName = (procedimento) => {
    const doctorName = procedimento?.medico_nome;

    if (!doctorName) return '';
    if (/^dr\.?|^dra\.?/i.test(doctorName.trim())) return toTitleCase(doctorName);

    const doctorPrefix = procedimento?.medico_sexo === 'F' ? 'Dra. ' : 'Dr. ';
    return `${doctorPrefix}${toTitleCase(doctorName)}`;
  };

  const getProcedureGroups = () => {
    const groups = new Map();

    state.item.forEach((procedimento, index) => {
      const schedule = getProcedureScheduleParts(procedimento);
      const isDoctorDependent = procedimento?.medico === true;
      const doctorDisplayName = isDoctorDependent ? getDoctorDisplayName(procedimento) : '';
      const doctorKey = isDoctorDependent
        ? procedimento?.medico_selecionado || doctorDisplayName || `medico-nao-informado-${index}`
        : 'sem-medico';
      const groupKey = isDoctorDependent
        ? `${schedule.dateKey}|medico|${doctorKey}|${schedule.scheduleKey}`
        : `${schedule.dateKey}|sem-medico|${schedule.scheduleKey}`;

      if (!groups.has(groupKey)) {
        groups.set(groupKey, {
          key: groupKey,
          dateText: schedule.dateText,
          detailText: schedule.detailText,
          dateKey: schedule.dateKey,
          sortTime: schedule.sortTime,
          firstIndex: index,
          doctorDisplayName,
          isDoctorDependent,
          procedures: [],
        });
      }

      groups.get(groupKey).procedures.push(procedimento);
    });

    return Array.from(groups.values()).sort((a, b) => {
      if (a.dateKey !== b.dateKey) return a.dateKey.localeCompare(b.dateKey);
      if (a.isDoctorDependent !== b.isDoctorDependent) return a.isDoctorDependent ? 1 : -1;
      if (a.sortTime !== b.sortTime) return a.sortTime.localeCompare(b.sortTime);
      return a.firstIndex - b.firstIndex;
    });
  };

  const useItem = getProcedureGroups().map((group, index) => {
    return (
      <Box
        key={group.key}
        pt={index === 0 ? 0 : 2}
        mt={index === 0 ? 0 : 2}
        borderTop={index === 0 ? 'none' : '1px solid'}
        borderColor="gray.100"
      >
        {group.doctorDisplayName ? (
          <Text color="gray.600" fontSize="0.78em" fontWeight="semibold" mb="1">
            {group.doctorDisplayName}
          </Text>
        ) : (
          <></>
        )}
        {group.procedures.map((procedimento, index) => (
          <Text key={`${group.key}-${procedimento?.procedimento_tuss_id || index}`} fontWeight="bold" fontSize="0.95em" lineHeight="1.35">
            {procedimento.nome}
          </Text>
        ))}
        <Box mt="1">
          <Text color="gray.500" fontSize="sm" fontWeight="semibold">
            {group.dateText || 'Data não informada'}
          </Text>
          {group.detailText ? (
            <Text color="gray.500" fontSize="sm" fontWeight="semibold">
              {group.detailText}
            </Text>
          ) : (
            <></>
          )}
        </Box>
      </Box>
    );
  });

  const useListProceduresHierar = preparos.map((procedure, index) => {
    const descricao_maiscula = procedure.descricao_pai.charAt(0).toUpperCase() + procedure.descricao_pai.slice(1);
    return (
      <div key={index}>
        <chakra.ul>
          <Text mt={'0.5em'}>{descricao_maiscula + ' ' + procedure.descricao}</Text>
        </chakra.ul>
      </div>
    );
  });

  function getMinorDateFromItemCart(array) {
    if (array.length === 0) return null;
    return array.reduce((menorData, item) => {
      const dataAtual = new Date(item.dia_selecionado);
      const dataMenor = menorData ? new Date(menorData) : null;
      if (!dataMenor || dataAtual < dataMenor) {
        return item.dia_selecionado;
      } else {
        return menorData;
      }
    }, null);
  }

  let data_parcela = '';
  if (user.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }
  const dataAtual = new Date();
  const clientePendente = user?.loggedIn && user?.qntdeParcelas?.countParcelas && user?.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela;

  return (
    <>
      {user.loggedIn ? <ChildHeader /> : <NoUserHeader />}
      <VStack
        w={{
          base: '90%',
          md: '500px',
        }}
        m="auto"
        alignItems="left"
        spacing={1}
        gap={2}
        marginBottom="10%"
      >
        <chakra.h1 fontWeight="bold" margin="5% 0 0 0" fontSize="xl">
          Informações do Pedido:
        </chakra.h1>
        <chakra.div>
          <chakra.p color="gray.500">Paciente:</chakra.p>
          <chakra.p fontWeight="bold">{state.paciente.nome.toUpperCase()}</chakra.p>
        </chakra.div>
        <chakra.div>
          <chakra.p color="gray.500">Procedimentos:</chakra.p>
          <Box>{useItem}</Box>
        </chakra.div>

        <chakra.div>
          <chakra.p color="gray.500">Local:</chakra.p>
          <chakra.p fontWeight="bold">{state.empresa.empresa_nome}</chakra.p>
          <chakra.p color="black.500" fontSize="xs">
            {' '}
            {state.empresa.endereco}
          </chakra.p>
        </chakra.div>

        <chakra.div>
          {(user.id_contrato > 0 || (user.loggedIn === true && user.titular === false)) && !clientePendente ? (
            <>
              <chakra.p color="gray.500">Valor particular:</chakra.p>
              <chakra.p fontWeight="bold">
                <chakra.del>{(state.valor + state.economia).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</chakra.del>
              </chakra.p>
              <chakra.p color="gray.500">Valor Deovita:</chakra.p>
              <chakra.p fontWeight="bold" fontSize={20} color={backgroundColor}>
                {state.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </chakra.p>
              <chakra.p fontWeight="bold" color={backgroundColor}>
                Economia de {state.economia.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} neste agendamento.
              </chakra.p>
            </>
          ) : (
            <>
              <chakra.p color="gray.500">Valor:</chakra.p>
              <chakra.p fontWeight="bold">{state.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</chakra.p>
            </>
          )}
        </chakra.div>
        <Container maxW="100%" w="100%" p={0} display="flex">
          <Box w="100%" padding="2" borderRadius="md" borderWidth="1px" borderColor="black">
            <chakra.p color="black" fontWeight="medium">
              Orientações:
            </chakra.p>
            <chakra.p color="red.500" margin="1% 0" fontSize="sm">
              {preparos && preparos?.length > 0 ? useListProceduresHierar : '- Sem informações.'}
            </chakra.p>
          </Box>
        </Container>

        <ButtonGroup pt="1rem" pb="15%" width="100%">
          <Button
            backgroundColor={backgroundColor}
            color="#FFF"
            width="100%"
            onClick={() => {
              confirmEstimate(state.orcamento_id);
               navigate('/exames/loading/', {
                  state: {
                    ...state,
                    valor: 0,
                    item: state.item,
                    paciente: state.paciente,
                    empresa: state.empresa,
                    horario: state.horario,
                    convenio: state.convenio,
                    data: currentDate,
                    confim: true,
                    transaction_id: 9999999,
                    isByOrder: state.isByOrder,
                  },
                });
                return
              if (!state.valor || state.valor === 0) {
                setUser((prevState) => ({ ...prevState, cart_temp: { itens: state.item } }));
               
              } else {
                setUser((prevState) => ({ ...prevState, cart_temp: { itens: state.item } }));
                console.log('data', {
                  ...state,
                  parcelsActive: true,
                  valor: state.valor,
                  expiration_pix_in_min: 5,
                  service: 'schedule_procedure',
                  navig_to: '/alerts/sucesso/agendamento-exame/',
                  split: splitRulesData,
                  item: {
                    valor: state.valor,
                    cpf: onlyNumbers(state.paciente.cpf),
                    nome: state.paciente.nome,
                    fone: state.paciente.celular,
                    email: state.paciente.email,
                    horario: state.horario,
                    empresa: state.empresa,
                    convenio: state.convenio,
                    data: state.data,
                    cart: state.item,
                    confim: true,
                    isByOrder: state.isByOrder,
                    solicitacao: state.solicitacao,
                    orcamentoId: state.orcamento_id,
                  },
                  valor_assinante: state.economia,
                });
                navigate('/pagamentos', {
                  state: {
                    ...state,
                    parcelsActive: true,
                    valor: state.valor,
                    expiration_pix_in_min: 5,
                    service: 'schedule_procedure',
                    navig_to: '/alerts/sucesso/agendamento-exame/',
                    split: splitRulesData,
                    frequenciaText: 'Pagamento de exames',
                    item: {
                      valor: state.valor,
                      cpf: onlyNumbers(state.paciente.cpf),
                      nome: state.paciente.nome,
                      fone: state.paciente.celular,
                      email: state.paciente.email,
                      horario: state.horario,
                      empresa: state.empresa,
                      convenio: state.convenio,
                      data: currentDate,
                      cart: state.item,
                      confim: true,
                      isByOrder: state.isByOrder,
                      solicitacao: state.solicitacao,
                      orcamentoId: state.orcamento_id,
                      id_recipient_solicitante: state.id_recipient_solicitante,
                      id_empresa_solicitante: state.id_empresa_solicitante,
                    },
                    valor_assinante: state.economia,
                  },
                });
              }
            }}
          >
            Ir para o pagamento
          </Button>
        </ButtonGroup>
      </VStack>
      <BottomNavBar />
    </>
  );
}

export default ConferePedido;
